import type { JiraIssueCreatePayload } from 'types/savings';

export const validateIssueCreatePayload = (payload: JiraIssueCreatePayload) => {
  return !!payload.jira_project_key &&
    !!payload.jira_issue_type &&
    !!payload.thread_id &&
    payload.opportunity_ids.length > 0;
}
